const ɵ0 = () => import("./../../../features/detail/detail.module.ngfactory").then(m => m.DetailModuleNgFactory), ɵ1 = () => import("./../../../features/campaign/campaign.module.ngfactory").then(m => m.CampaignModuleNgFactory), ɵ2 = () => import("./../../../features/list/list.module.ngfactory").then(m => m.ListModuleNgFactory), ɵ3 = () => import("./../../../features/search/search.module.ngfactory").then(m => m.SearchModuleNgFactory), ɵ4 = () => import("./../../../features/calendar/calendar.module.ngfactory").then(m => m.CalendarModuleNgFactory), ɵ5 = () => import("./../../components/finder-map/finder-map.module.ngfactory").then(m => m.FinderMapModuleNgFactory), ɵ6 = () => import("./../../../features/events/live.module.ngfactory").then(m => m.LiveModuleNgFactory), ɵ7 = () => import("./../../../features/events/live-header/live-header.module.ngfactory").then(m => m.LiveHeaderModuleNgFactory), ɵ8 = () => import("./../../../features/events/live-footer/live-footer.module.ngfactory").then(m => m.LiveFooterModuleNgFactory), ɵ9 = () => import("./../../components/debug-panel/debug-panel.module.ngfactory").then(m => m.DebugPanelModuleNgFactory), ɵ10 = () => import("./../../components/finder-discounts-modal/finder-discounts-modal.module.ngfactory").then(m => m.FinderDiscountsModalModuleNgFactory);
/**
 * Writing the bundles using dynamic import with path and loadChildren properties we trick webpack
 * to think these are going to be use as a router configuration and it will create js bundles for each of them.
 */
export const lazyBundles = [
    {
        path: 'finder-detail',
        loadChildren: ɵ0
    },
    {
        path: 'finder-campaign',
        loadChildren: ɵ1
    },
    {
        path: 'finder-list',
        loadChildren: ɵ2
    },
    {
        path: 'finder-search',
        loadChildren: ɵ3
    },
    {
        path: 'finder-calendar',
        loadChildren: ɵ4
    },
    {
        path: 'finder-map',
        loadChildren: ɵ5
    },
    {
        path: 'live-commerce',
        loadChildren: ɵ6
    },
    {
        path: 'live-header',
        loadChildren: ɵ7
    },
    {
        path: 'live-footer',
        loadChildren: ɵ8
    },
    {
        path: 'debug-panel',
        loadChildren: ɵ9
    },
    {
        path: 'discounts-modal',
        // If we break this line webpack doesn't want to create the bundle
        // so I had to disable max-length rule here
        // tslint:disable-next-line: max-line-length
        loadChildren: ɵ10
    },
];
export function lazyArrayToObj() {
    return lazyBundles.reduce((result, bundle) => {
        result[bundle.path] = bundle.loadChildren;
        return result;
    }, {});
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10 };
